"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var PlayerDetails_module_css_1 = __importDefault(require("./PlayerDetails.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var PlayerTypes_1 = __importDefault(require("@/functions/PlayerTypes"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var DateTimePicker_1 = __importDefault(require("../common/DateTimePicker"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var PlayerType = function (_a) {
    var player = _a.player, t = _a.t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { color: "var(--info-color)" }, className: "ns-font-size-17 ns-font-family-bold" },
            t("Player type"),
            ":"),
        react_1.default.createElement("div", { className: "".concat(PlayerDetails_module_css_1.default.playerTypeContainer, " d-flex align-items-center") },
            react_1.default.createElement("img", { src: PlayerTypes_1.default.getPlayerTypeIconByDeviceId(player.device_type_id), style: { margin: "0 auto", width: "50px" }, title: player.device_type.name }))));
};
var ScreenSchedule = function (_a) {
    var t = _a.t, setActiveProp = _a.setActiveProp, permissions = _a.permissions, player = _a.player, resourceType = _a.resourceType;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ns-font-family-bold ns-font-size-17", style: { color: "var(--info-color)" } },
            t("On/Off Screen (Black Screen)"),
            ":"),
        react_1.default.createElement("div", { className: "d-flex mt-2" },
            react_1.default.createElement(AccessControl_1.default, { resourceId: player.id, resourceType: resourceType, conditionalChildren: [
                    {
                        permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Change settings"), onClick: function () { return setActiveProp("BlackScreenSchedule"); }, size: "small", variant: "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), dataCy: "blackScreenScheduleButton" }))
                    },
                    {
                        permission: permissions.read,
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Change settings"), size: "small", variant: "primary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), dataCy: "blackScreenScheduleButton", disabled: true }))
                    }
                ] })));
};
var AttachedPlayerPresentations = function (_a) {
    var _b;
    var playerId = _a.playerId, t = _a.t, toggleAddPresentations = _a.toggleAddPresentations, isShown = _a.isShown, permissions = _a.permissions, resourceType = _a.resourceType;
    var _c = (0, react_1.useState)({ data: [] }), attachedPresentations = _c[0], setAttachedPresentations = _c[1];
    var updatePlayerPresentationScheduleDebouncer = (0, react_1.useState)(new q_play_core_1.Debouncer(function (playerPresentationId, body) {
        ApiManager_1.default.updateScheduleOnPlayerPresentation(playerPresentationId, body).catch(function (err) {
            logger.error("Updating schedule for presentation attached to player failed: ", err);
        });
    }, 650))[0];
    var logger = q_play_core_1.logManager.getLogger();
    (0, react_1.useEffect)(function () {
        var getAttachedPresentations = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getPlayerPresentations(playerId)];
                    case 1:
                        response = _a.sent();
                        setAttachedPresentations(response);
                        return [2 /*return*/];
                }
            });
        }); };
        if (isShown) {
            getAttachedPresentations();
        }
    }, [isShown]);
    var setActiveFromOrTo = (0, react_1.useCallback)(function (playerPresentationId, fromOrTo, value) { return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            body = fromOrTo === "from" ? { active_from: value } : { active_to: value };
            setAttachedPresentations(function (attachedPresentations) {
                return {
                    data: attachedPresentations.data.map(function (pp) {
                        if (pp.id === playerPresentationId)
                            return __assign(__assign(__assign({}, pp), (fromOrTo === "from" && { active_from: value })), (fromOrTo === "to" && { active_to: value }));
                        else
                            return pp;
                    })
                };
            });
            updatePlayerPresentationScheduleDebouncer.debounce(playerPresentationId, body);
            return [2 /*return*/];
        });
    }); }, [attachedPresentations]);
    function setActiveFromOrToOnPlayerPresentations(playerPresentationId, fromOrTo, dateTimeString) {
        if (fromOrTo === "active_from") {
            if (dateTimeString === "")
                setActiveFromOrTo(playerPresentationId, "from", "");
            else
                setActiveFromOrTo(playerPresentationId, "from", (dateTimeString));
        }
        else {
            if (dateTimeString === "")
                setActiveFromOrTo(playerPresentationId, "to", "");
            else
                setActiveFromOrTo(playerPresentationId, "to", (dateTimeString));
        }
    }
    var detachPresentationFromPlayer = function (presentationVersionId, playerId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.deletePlayerPresentation(presentationVersionId, playerId)];
                case 1:
                    response = _a.sent();
                    setAttachedPresentations(response);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "col-sm" },
        react_1.default.createElement("span", { className: "d-flex ns-font-family-bold ns-font-size-17 mb-3", style: { color: "var(--info-color)" } },
            t("Presentations attached"),
            ":"),
        react_1.default.createElement("div", { className: "".concat(PlayerDetails_module_css_1.default.scrollableContainer, " col-sm"), style: { maxHeight: "375px", paddingRight: "5px", marginBottom: "50px" }, "data-cy": "attachedPlayerPresentations" }, (_b = attachedPresentations.data) === null || _b === void 0 ? void 0 :
            _b.map(function (presentation) {
                return (react_1.default.createElement("div", { key: presentation.id, className: "".concat(PlayerDetails_module_css_1.default.presentationName, " d-flex align-items-center justify-content-between ns-font-family ns-font-size-14") },
                    presentation.presentation_name,
                    react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                            {
                                permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                                children: (react_1.default.createElement("div", { className: "d-flex justify-content-between", style: { width: "340px" } },
                                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                                        react_1.default.createElement(DateTimePicker_1.default, { timePicker: true, dateTimeString: "".concat(presentation.active_from), onSelect: function (dateTimeString) { setActiveFromOrToOnPlayerPresentations(presentation.id, "active_from", dateTimeString); }, showClockIcon: true, style: { paddingLeft: "0.5em", width: "138px", height: "32px" }, placeholderText: t("Start") }),
                                        react_1.default.createElement("div", { style: { margin: "0px 8px" } }, "\u2014"),
                                        react_1.default.createElement(DateTimePicker_1.default, { timePicker: true, dateTimeString: "".concat(presentation.active_to), onSelect: function (dateTimeString) { setActiveFromOrToOnPlayerPresentations(presentation.id, "active_to", dateTimeString); }, showClockIcon: true, style: { paddingLeft: "0.5em", width: "138px", height: "32px" }, placeholderText: t("End") })),
                                    react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, onClick: function () {
                                            return detachPresentationFromPlayer(presentation.presentation_version_id, playerId);
                                        } },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" }))))
                            },
                            {
                                permission: permissions.read,
                                children: (react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, disabled: true },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" })))
                            }
                        ] })));
            }),
            react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                    {
                        permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "primary", className: "d-flex justify-content-center align-items-center w-100", onClick: toggleAddPresentations, dataCy: "addPresentationButton" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    },
                    {
                        permission: permissions.read,
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "secondary", className: "d-flex justify-content-center align-items-center w-100", disabled: true },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    }
                ] }))));
};
var AttachedPlayerEvents = function (_a) {
    var playerId = _a.playerId, t = _a.t, toggleAddEvents = _a.toggleAddEvents, isShown = _a.isShown, permissions = _a.permissions, resourceType = _a.resourceType;
    var _b = (0, react_1.useState)([]), attachedEvents = _b[0], setAttachedEvents = _b[1];
    var logger = q_play_core_1.logManager.getLogger();
    (0, react_1.useEffect)(function () {
        var getAttachedEvents = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiManager_1.default.getPlayerEvents([playerId])];
                    case 1:
                        response = _a.sent();
                        setAttachedEvents(response);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.error("Error fetching player events:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (isShown) {
            getAttachedEvents();
        }
    }, [isShown, playerId]);
    var removePlayerEvent = function (eventId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deletePlayerEvent(playerId, eventId)];
                case 1:
                    _a.sent();
                    setAttachedEvents(function (prevEvents) { return prevEvents.filter(function (event) { return event.event_id !== eventId; }); });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error deleting player event:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var formatDate = function (dateNumber) {
        if (!dateNumber)
            return t("No date");
        var dateString = dateNumber.toString();
        var year = dateString.substring(0, 4);
        var month = dateString.substring(4, 6);
        var day = dateString.substring(6, 8);
        var hour = dateString.substring(8, 10);
        var minute = dateString.substring(10, 12);
        return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minute);
    };
    return (react_1.default.createElement("div", { className: "col-sm" },
        react_1.default.createElement("span", { className: "d-flex ns-font-family-bold ns-font-size-17 mb-3", style: { color: "var(--info-color)" } },
            t("Events attached"),
            ":"),
        react_1.default.createElement("div", { className: "".concat(PlayerDetails_module_css_1.default["scrollable-event-container"], " col-sm") },
            attachedEvents.map(function (event) { return (react_1.default.createElement("div", { key: event.event_id, className: "".concat(PlayerDetails_module_css_1.default["event-name"], " d-flex align-items-center justify-content-between ns-font-family ns-font-size-14"), "data-cy": "attachedEventsName" },
                event.event_title,
                react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                        {
                            permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                            children: (react_1.default.createElement("div", { className: "d-flex justify-content-end", style: { width: "340px" } },
                                react_1.default.createElement("div", { className: "d-flex align-items-center", style: { width: "340px" } },
                                    react_1.default.createElement(q_play_components_1.Input, { type: "text", readOnly: true, value: formatDate(event.start), className: PlayerDetails_module_css_1.default["event-date-input"] }),
                                    react_1.default.createElement("div", { style: { margin: "0px 8px" } }, "\u2014"),
                                    react_1.default.createElement(q_play_components_1.Input, { type: "text", readOnly: true, value: formatDate(event.end), className: PlayerDetails_module_css_1.default["event-date-input"] })),
                                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, onClick: function () { return removePlayerEvent(event.event_id); } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" }))))
                        },
                        {
                            permission: permissions.read,
                            children: (react_1.default.createElement("div", { className: "d-flex justify-content-end", style: { width: "340px" } },
                                react_1.default.createElement("div", { className: "d-flex align-items-center", style: { width: "340px" } },
                                    react_1.default.createElement(q_play_components_1.Input, { type: "text", readOnly: true, value: formatDate(event.start), className: PlayerDetails_module_css_1.default["event-date-input"] }),
                                    react_1.default.createElement("div", { style: { margin: "0px 8px" } }, "\u2014"),
                                    react_1.default.createElement(q_play_components_1.Input, { type: "text", readOnly: true, value: formatDate(event.end), className: PlayerDetails_module_css_1.default["event-date-input"] })),
                                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, disabled: true },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" }))))
                        }
                    ] }))); }),
            react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                    {
                        permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "primary", className: "d-flex justify-content-center align-items-center w-100", onClick: toggleAddEvents, dataCy: "addPlayerEventButton" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    },
                    {
                        permission: permissions.read,
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "secondary", className: "d-flex justify-content-center align-items-center w-100", disabled: true },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    }
                ] }))));
};
var AttachedPlayerMetadata = function (_a) {
    var playerId = _a.playerId, t = _a.t, toggleAddMetadata = _a.toggleAddMetadata, isShown = _a.isShown, permissions = _a.permissions, resourceType = _a.resourceType;
    var _b = (0, react_1.useState)([]), attachedMetadata = _b[0], setAttachedMetadata = _b[1];
    var logger = q_play_core_1.logManager.getLogger();
    (0, react_1.useEffect)(function () {
        var getAttachedMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, parsedMetadata, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiManager_1.default.getPlayerMetadata(playerId)];
                    case 1:
                        response = _a.sent();
                        if (response.metadata) {
                            parsedMetadata = response.metadata.map(function (item) { return (__assign(__assign({}, item), { metadata: JSON.parse(item.keys) })); });
                            setAttachedMetadata(parsedMetadata);
                        }
                        else {
                            setAttachedMetadata([]);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        logger.error("Error fetching player metadata:", error_3);
                        setAttachedMetadata([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (isShown) {
            getAttachedMetadata();
        }
    }, [isShown, playerId]);
    var removeMetadata = function (metadataId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteMetadataFromPlayer(playerId, metadataId)];
                case 1:
                    _a.sent();
                    setAttachedMetadata(function (prevMetadata) { return prevMetadata.filter(function (metadata) { return metadata.metadata_id !== metadataId; }); });
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    logger.error("Error deleting player metadata:", error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderTooltipContent = function (metadata) {
        var meta_key = metadata.meta_key, description = metadata.description, metadataObject = metadata.metadata;
        var displayObject = {};
        if (metadataObject) {
            displayObject = Array.isArray(metadataObject)
                ? metadataObject.reduce(function (acc, item) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[item] = item, _a)));
                }, {})
                : metadataObject;
        }
        var entries = Object.entries(displayObject);
        var columns = [];
        for (var i = 0; i < entries.length; i += 7) {
            columns.push(entries.slice(i, i + 7));
        }
        return (react_1.default.createElement("pre", { style: { margin: 0, padding: 0, fontFamily: "Geomanist" } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null,
                    t("Metadata"),
                    ":"),
                " ",
                meta_key),
            react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null, t("Description")),
                " ",
                description),
            columns.length > 0 && (react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null,
                    t("Elements"),
                    ":"),
                react_1.default.createElement("div", { style: { display: "flex", gap: "20px", marginTop: "8px" } }, columns.map(function (column, colIndex) { return (react_1.default.createElement("div", { key: "column-".concat(colIndex), style: { display: "flex", flexDirection: "column" } }, column.map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return (react_1.default.createElement("div", { key: "".concat(key, "-").concat(value) },
                        react_1.default.createElement("strong", null,
                            key,
                            ":"),
                        " ",
                        value));
                }))); }))))));
    };
    return (react_1.default.createElement("div", { className: "col-sm" },
        react_1.default.createElement("span", { className: "d-flex ns-font-family-bold ns-font-size-17 mb-3", style: { color: "var(--info-color)" } },
            t("Metadata attached"),
            ":"),
        react_1.default.createElement("div", { className: "".concat(PlayerDetails_module_css_1.default["scrollable-metadata-container"], " col-sm") },
            attachedMetadata.length > 0 && attachedMetadata.map(function (metadata) { return (react_1.default.createElement(Tooltip_1.default, { key: metadata.metadata_id, title: renderTooltipContent(metadata), placement: "top", arrow: true, PopperProps: {
                    sx: {
                        ".MuiTooltip-arrow": {
                            color: "var(--secondary-color)",
                        },
                        ".MuiTooltip-tooltip": {
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            borderRadius: "7px",
                            padding: "12px",
                            maxWidth: "none",
                            overflow: "visible",
                            whiteSpace: "normal",
                        },
                    },
                } },
                react_1.default.createElement("div", { style: { display: "flex", width: "100%", alignItems: "center" }, className: PlayerDetails_module_css_1.default["metadata-name"] },
                    react_1.default.createElement("div", { style: { flex: "0 0 30%", marginRight: "10px", maxWidth: "30%" } },
                        react_1.default.createElement("div", { style: {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }, className: "ns-font-family ns-font-size-14" },
                            react_1.default.createElement("strong", { "data-cy": "attachedMetadataName" }, metadata.meta_key),
                            ": ",
                            metadata.description)),
                    react_1.default.createElement("div", { style: { flex: "1 0 60%", maxWidth: "60%" } },
                        react_1.default.createElement("div", { style: {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "var(--info-color)",
                            } }, metadata.metadata && Object.entries(metadata.metadata).map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return (react_1.default.createElement("span", { key: "".concat(key, "-").concat(value), style: { fontSize: "0.9em", marginRight: "5px" } },
                                react_1.default.createElement("strong", null, key),
                                ": ",
                                value));
                        }))),
                    react_1.default.createElement("div", { style: {
                            flex: "0 0 9%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end"
                        } },
                        react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                                {
                                    permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                                    children: (react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, onClick: function () { return removeMetadata(metadata.metadata_id); } },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" })))
                                },
                                {
                                    permission: permissions.read,
                                    children: (react_1.default.createElement(q_play_components_1.Button, { variant: "empty", style: { minWidth: "unset", padding: "unset" }, disabled: true },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, color: "var(--info-color)", className: "me-2" })))
                                }
                            ] }))))); }),
            react_1.default.createElement(AccessControl_1.default, { resourceId: playerId, resourceType: resourceType, conditionalChildren: [
                    {
                        permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "primary", className: "d-flex justify-content-center align-items-center w-100", onClick: toggleAddMetadata, dataCy: "addPlayerMetadataButton" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    },
                    {
                        permission: permissions.read,
                        children: (react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "secondary", className: "d-flex justify-content-center align-items-center w-100", disabled: true },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))
                    }
                ] }))));
};
var PlayerFunctions = function (_a) {
    var player = _a.player, t = _a.t, permissions = _a.permissions, resourceType = _a.resourceType;
    var runCommand = function (command) { return __awaiter(void 0, void 0, void 0, function () {
        var response, setCommand, playerCommands, index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.toggleCommand(command, Number(player.id))];
                case 1:
                    response = _a.sent();
                    setCommand = "set" + command;
                    playerCommands = (JSON.parse(player.commands)) || [];
                    if (response > 0) {
                        eval(setCommand + "(true)"); // If you think that this is a security issue, please come with an example :p
                        playerCommands.push(command);
                    }
                    else {
                        eval(setCommand + "(false)");
                        index = playerCommands === null || playerCommands === void 0 ? void 0 : playerCommands.indexOf(command);
                        if (index > -1) { // only splice array when item is found
                            playerCommands.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    player.commands = JSON.stringify(playerCommands);
                    return [2 /*return*/];
            }
        });
    }); };
    // Player commands - note that the camel notation is "broken" on purpouse
    var _b = (0, react_1.useState)(false), relaunchPlayer = _b[0], setrelaunchPlayer = _b[1];
    var _c = (0, react_1.useState)(false), updateSoftware = _c[0], setupdateSoftware = _c[1];
    var _d = (0, react_1.useState)(false), clearCache = _d[0], setclearCache = _d[1];
    (0, react_1.useEffect)(function () {
        if (player && "commands" in player && player.commands != null) {
            var playerCommands = JSON.parse(player.commands);
            setrelaunchPlayer(playerCommands.includes("relaunchPlayer") ? true : false);
            setupdateSoftware(playerCommands.includes("updateSoftware") ? true : false);
            setclearCache(playerCommands.includes("clearCache") ? true : false);
        }
        else {
            setrelaunchPlayer(false);
            setupdateSoftware(false);
            setclearCache(false);
        }
    }, [player.commands]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "ns-font-family-bold ns-font-size-17", style: { color: "var(--info-color)" } },
                t("Functions"),
                ":"),
            react_1.default.createElement("div", { className: "d-flex mt-2" },
                react_1.default.createElement(AccessControl_1.default, { resourceId: player.id, resourceType: resourceType, conditionalChildren: [
                        {
                            permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                            children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Restart"), onClick: function () { return runCommand("relaunchPlayer"); }, size: "small", variant: relaunchPlayer ? "primary" : "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3") }))
                        },
                        {
                            permission: permissions.read,
                            children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Restart"), size: "small", variant: "primary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), disabled: true }))
                        }
                    ] }),
                react_1.default.createElement(AccessControl_1.default, { resourceId: player.id, resourceType: resourceType, conditionalChildren: [
                        {
                            permission: permissions.manage,
                            children: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Update"), onClick: function () { return runCommand("updateSoftware"); }, size: "small", variant: updateSoftware ? "primary" : "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3") }),
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Clear cache"), onClick: function () { return runCommand("clearCache"); }, size: "small", variant: clearCache ? "primary" : "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3") })))
                        },
                        {
                            permission: permissions.write,
                            children: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Update"), size: "small", variant: "primary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), disabled: true }),
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Clear cache"), onClick: function () { return runCommand("clearCache"); }, size: "small", variant: clearCache ? "primary" : "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3") })))
                        },
                        {
                            permission: permissions.read,
                            children: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Update"), size: "small", variant: "primary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), disabled: true }),
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Clear cache"), size: "small", variant: "primary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), disabled: true })))
                        }
                    ] })))));
};
var PlayerLink = function (_a) {
    var player = _a.player, t = _a.t, permissions = _a.permissions;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)(false), isCopied = _b[0], setIsCopied = _b[1];
    var copyPlayerLink = function () {
        var url = "".concat(process.env.QPLAY_EDITOR_HOST, "/playContent?token=").concat(player.player_token);
        navigator.clipboard.writeText(url)
            .then(function () {
            setIsCopied(true);
            setTimeout(function () { return setIsCopied(false); }, 3000);
        })
            .catch(function (err) {
            logger.error("Failed to copy to clipboard:", err);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, player.device_type.id === 1 && (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "mt-2 ns-font-family-bold ns-font-size-17", style: { color: "var(--info-color)" } },
            t("Player Link"),
            ":"),
        react_1.default.createElement("div", { className: "d-flex flex-column mt-2" },
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement(AccessControl_1.default, { resourceId: player.id, optionalPermissions: permissions.read },
                    react_1.default.createElement(q_play_components_1.Button, { text: isCopied ? t("Player link copied!") : t("Copy player link"), onClick: copyPlayerLink, size: "small", variant: "secondary", className: "".concat(PlayerDetails_module_css_1.default.button, " d-flex align-items-center me-3"), dataCy: "copyPlayerLinkButton" }))))))));
};
var PlayerDetailsGeneralTab = function (_a) {
    var player = _a.player, toggleAddPresentations = _a.toggleAddPresentations, toggleAddEvents = _a.toggleAddEvents, toggleAddMetadata = _a.toggleAddMetadata, setActiveProp = _a.setActiveProp, isShown = _a.isShown, permissions = _a.permissions, resourceType = _a.resourceType;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    if (player) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { display: "flex", marginBottom: "2rem" } },
                react_1.default.createElement("div", { style: { flex: "1 1 auto" } },
                    react_1.default.createElement(PlayerType, { player: player, t: t })),
                react_1.default.createElement("div", { style: {
                        flex: "1 1 auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    } },
                    react_1.default.createElement(ScreenSchedule, { t: t, setActiveProp: setActiveProp, permissions: permissions, player: player, resourceType: resourceType }),
                    player.device_type.id !== 1 && (react_1.default.createElement(PlayerFunctions, { player: player, t: t, permissions: permissions, resourceType: resourceType })),
                    react_1.default.createElement(PlayerLink, { player: player, t: t, permissions: permissions }))),
            react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.container },
                react_1.default.createElement(AttachedPlayerPresentations, { playerId: player.id, t: t, toggleAddPresentations: toggleAddPresentations, isShown: isShown, permissions: permissions, resourceType: resourceType })),
            react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.container },
                react_1.default.createElement(AttachedPlayerEvents, { playerId: player.id, t: t, toggleAddEvents: toggleAddEvents, isShown: isShown, permissions: permissions, resourceType: resourceType })),
            react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.container },
                react_1.default.createElement(AttachedPlayerMetadata, { playerId: player.id, t: t, toggleAddMetadata: toggleAddMetadata, isShown: isShown, permissions: permissions, resourceType: resourceType }))));
    }
};
exports.default = PlayerDetailsGeneralTab;
